import { useParams } from "react-router";

import { PathParams } from "./path_param.decl";

export function usePathParams(): PathParams {
  const { callId, callType } = useParams<PathParams>() as PathParams;
  return { callId, callType };
}
